import { render, staticRenderFns } from "./ToggleContent.vue?vue&type=template&id=36a833fb&"
import script from "./ToggleContent.vue?vue&type=script&lang=js&"
export * from "./ToggleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports